import { Mail, Phone, Plus } from "lucide-react";
import { useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import type { Contact } from "@/lib/types";
import { cn } from "@/lib/utils";
import { ContactDialog } from "./ContactDialog";

export function Contacts({ companyId, contacts }: { companyId: number; contacts: Contact[] }) {
  const [open, setOpen] = useState<Contact | "new" | null>(null);
  return (
    <section aria-labelledby="contacts-title" className="space-y-3">
      <div className="flex items-center justify-between">
        <h2 id="contacts-title" className="text-base font-semibold">Kontakte</h2>
        <Button variant="ghost" size="sm" onClick={() => setOpen("new")}><Plus />Kontakt</Button>
      </div>
      {contacts.length === 0 && <p className="text-sm text-muted-foreground">Noch keine Kontakte.</p>}
      {/* Phones: horizontal scroller; wider screens: a stacked list. */}
      <ul className="flex gap-3 overflow-x-auto pb-1 max-lg:snap-x lg:flex-col lg:overflow-visible">
        {contacts.map((k) => (
          <li key={k.id} className={cn("min-w-60 snap-start rounded-xl p-3 ring-1 ring-border lg:min-w-0", k.archived_at && "opacity-60")}>
            <button type="button" onClick={() => setOpen(k)} className="w-full text-left">
              <span className="flex items-center gap-2">
                <span className="truncate font-medium">{k.name}</span>
                {k.is_primary === 1 && <Badge variant="secondary">Hauptkontakt</Badge>}
                {k.archived_at && <Badge variant="outline">archiviert</Badge>}
              </span>
              {k.role && <span className="block text-sm text-muted-foreground">{k.role}</span>}
            </button>
            <div className="mt-2 flex flex-wrap gap-x-3 gap-y-1 text-sm">
              {k.email && <a href={`mailto:${k.email}`} className="inline-flex items-center gap-1 text-muted-foreground hover:text-foreground"><Mail className="size-3.5" />{k.email}</a>}
              {k.phone && <a href={`tel:${k.phone.replace(/\s/g, "")}`} className="inline-flex items-center gap-1 text-muted-foreground tabular-nums hover:text-foreground"><Phone className="size-3.5" />{k.phone}</a>}
            </div>
          </li>
        ))}
      </ul>
      <ContactDialog companyId={companyId} contact={open} onClose={() => setOpen(null)} />
    </section>
  );
}
